import apiRequestType from "../apiRequestType";
import { apiTypes } from "../../utils/apiTypes";
import { apiConstants } from "../../utils/apiConstants";

const getTopicByID = (data) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.ORGANIZE.GET_TOPIC_BY_ID(data),
  );
};

export default getTopicByID;